import React from 'react'

const AppFooter = () => {
  return (
    <div>footer</div>
  )
}

export default AppFooter